import { CSSProperties } from "react";

/**
 * Dynamically generates a CSS property object for Tailwind CSS classes.
 * This function takes a CSS variable name, a value for that variable, and a default value to use if the primary value is nullish.
 * It returns an object that can be used as CSSProperties in styled-components, making it particularly useful for integrating Tailwind CSS.
 *
 * @param variable - A string representing the CSS variable name to be used as the property key. SHOULD accomplish with pattern "--hello[-world]*".
 * @param value - The value to be assigned to the CSS variable
 * @returns An object of type CSSProperties where the key is the `variable`.
 *
 * Example:
 * generateTailwindVariableClasses("--text-color", "#fff")
 * // Returns: { "--text-color": "#fff" }
 */
const generateTailwindVariableClasses = (variable: string, value: string): CSSProperties => {
	return { [`${variable}`]: value } as CSSProperties;
};

export default generateTailwindVariableClasses;
